import { createContext } from 'react';
export var apiClientContext = createContext(undefined);

//# sourceMappingURL=apiClientContext.js.map
